import { render } from "./left.svg?vue&type=template&id=60598c1f"
const script = {}

import exportComponent from "/buddy/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__